<template>
  <div class="qsPageBox">
    <div class="qsPage">
      <div class="userBox">
        <el-descriptions :column="1">
            <el-descriptions-item :label="Language('客户姓名')">{{uForm.cusName}}</el-descriptions-item>
            <el-descriptions-item :label="Language('电话')">{{uForm.tel}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="agentBox">
        <el-form ref="form" label-width="80px" size="small">
          <el-form-item :label="Language('外呼状态')">
            <el-select v-model="tForm.status" :placeholder="Language('外呼状态')">
              <el-option :label="Language('未呼出')" value="0"></el-option>
              <el-option :label="Language('呼叫成功')" value="1"></el-option>
              <el-option :label="Language('呼叫失败')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="Language('外呼内容')">
            <el-input v-model="tForm.content" :placeholder="Language('外呼内容')" type="textarea" :rows="4" maxlength="500"></el-input>
          </el-form-item>
          <el-form-item :label="Language('是否完成')">
            <el-radio-group v-model="recordStatus">
              <el-radio label="1">{{Language('是')}}</el-radio>
              <el-radio label="0">{{Language('否')}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="Language('完成说明')">
            <el-input v-model="reason" :placeholder="Language('完成说明')" type="textarea" :rows="4" maxlength="500"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="medium" @click="useApiSaveInfoFn" :disabled="!lock">{{Language('提交')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { useApiSaveInfo } from "../../http/Questionnaire.js";
import { getTimes } from "../../components/Common/datetime.js";

export default {
  name: "defaultPage",
  components: {},
  data() {
    return {
      vdnId: '',
      tForm: { //外拨任务信息
        taskDetId: '', //任务明细id
        taskId: '', //任务id
        status: '1', //外拨状态 0.未呼出 1.已呼出 2.呼叫失败 3.超时取消 4.取消
        popupType: '', //外呼弹屏类型
        content: '', //外呼内容，坐席录入
        callPid: '', //通话PID
      },
      uForm: { //客户信息
        cusId: '', //客户ID
        cusName: '', //客户姓名
        tel: '', //电话
      },
      sourceType: '', //问卷来源，0.外发调查 1.回访调查
      sourceId: '', //来源ID
      recordStatus: '1', //是否完成，0.否 1.是
      reason: '', //完成说明 坐席填写
      lock: true,
    };
  },
  watch: {},
  created() {
    document.title = '回访调查'
  },
  mounted() {
    this.vdnId = this.$route.query.vdnId
    this.sourceType = this.$route.query.sourceType
    this.sourceId = this.$route.query.sourceId

    this.tForm.taskDetId = this.$route.query.taskDetId
    this.tForm.taskId = this.$route.query.taskId
    this.tForm.popupType = this.$route.query.popupType
    this.tForm.callPid = this.$route.query.pId

    this.uForm.cusId = this.$route.query.cusId
    this.uForm.cusName = this.$route.query.cusName
    this.uForm.tel = this.$route.query.tel
  },
  watch: {},
  methods: {
    //提交
    useApiSaveInfoFn(){
      let data = {
        vdnId: this.vdnId,
        qsId: '',
        sourceType: this.sourceType,
        sourceId: this.sourceId,
        recordStatus: this.recordStatus,
        totalScore: 0,
        begDate: getTimes(),
        ...this.tForm,
        ...this.uForm,
        reason: this.reason,
        answerData: []
      }
      this.lock = false
      useApiSaveInfo(data).then((res) => {
        if (res) {
          if (res.retCode == 1) {
            this.$Msg.success('操作成功');
            setTimeout(()=>{
              //提交成功后，通知呼叫页面进行对应刷新
              top.postMessage({message: 'refreshlist', tipsType: '0'}, '*')
            }, 2000)
          }
        }
      });
    },
  }
};
</script>

<style scoped lang="scss">
  .qsPageBox{
    background: #f7f8fa;
    position: relative;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: auto;
  }
  .qsPage{
    width: 1030px;
    box-sizing: border-box;
    background-color: #fff;
    position: relative;
    padding: 0 15px;
    margin: 0 auto;
    height: fit-content;
    min-height: 100%;
    h1{
      padding: 30px;
      text-align: center;
    }
  }
  .qsPage.phoneView{
    width: 100%;
    padding: 0;
    h1{
      font-size: 22px;
    }
    .qsBottom button{
      width: 100%;
      font-size: 20px;
    }
  }
  
  .guideCnt{
    padding: 15px 30px;
    font-size: 16px;
    text-align: center;
  }
  .qsBox{
    padding: 30px 0;
  }
  .qsItem{
    padding: 15px;
  }
  .qsTitle{
    font-size: 16px;
    font-weight: bold;
  }
  .qsContent-item{
    margin: 20px 0 0;
    .el-radio{
      margin-right: 15px;
      >>> .el-radio__label{
        font-size: 16px;
        color: #535862;
      }
    }
    .el-checkbox{
      margin-right: 15px;
      >>> .el-checkbox__label{
        font-size: 16px;
        color: #535862;
      }
    }
  }
  .qsBottom{
    padding: 15px;
  }
  .userBox{
    padding: 15px 15px 0;
  }
  .moreType{
    color: #989DAA;
    font-weight: normal;
  }
  .tips{
    font-size: 16px;
    padding: 30px 0;
  }
  .qsRed{
    border: red 1px solid;
  }
  .agentBox{
    padding: 15px 15px 0;
    border-top: #e9e9e9 1px solid;
  }
</style>



// WEBPACK FOOTER //
// defaultPage.vue?0a30db49